module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Imljb24vd2FybmluZyI+CjxwYXRoIGlkPSJWZWN0b3IiIGQ9Ik0xMyAxNEgxMVY5SDEzVjE0Wk0xMyAxOEgxMVYxNkgxM1YxOFpNMSAyMUgyM0wxMiAyTDEgMjFaIiBmaWxsPSIjRjdDNzUyIi8+CjwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/ic_warning.svg
// module id = 5/rt
// module chunks = 1